import useApi, { ApiOptions } from '../base/useApi';
import JobDTO from '@src/adapters/dto/job/JobDTO';

interface Params {
  id: string;
}

interface Result {
  job: JobDTO;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/job',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindJobLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindJobLazy;
